import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {

  constructor(private tokenService : TokenService, private http : HttpClient, private encryptService:EncryptionService) { }

  getNbTraites(dateDebut : string, dateFin : string, cq:number=0, all:boolean=false, choosenPers:number, typeFiche:string) {
    let httpHeaders = this.tokenService.loadToken();
    
    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === true) {
      user = "all"
      if(choosenPers !== 0) user = choosenPers;
    }
    
    let request = "/api/performance/fiches-traitees?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&cq=" + cq + "&type-fiche=" + typeFiche;
    
    return this.http.get(request, {headers : httpHeaders});
  }

  getGainPerte(dateDebut : string, dateFin : string, cq:number=0, all:boolean=false, choosenPers:number, typeFiche:string) {
    let httpHeaders = this.tokenService.loadToken();
    
    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === true) {
      user = "all"
      if(choosenPers !== 0) user = choosenPers;
    }
    
    let request = "/api/performance/gain-perte?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&cq=" + cq + "&type-fiche=" + typeFiche;
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getDmtMoyenne(dateDebut : string, dateFin : string, cq:number=0, all:boolean=false, choosenPers:number, typeFiche:string) {
    let httpHeaders = this.tokenService.loadToken();
    
    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === true) {
      user = "all"
      if(choosenPers !== 0) user = choosenPers;
    }

    let request = "/api/performance/dmt-moyenne?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&cq=" + cq + "&type-fiche=" + typeFiche;
    
    return this.http.get(request, {headers : httpHeaders});
  }

  getTauxIso(dateDebut : string, dateFin : string, all:boolean=false, choosenPers:number, typeFiche:string) {
    let httpHeaders = this.tokenService.loadToken();

    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === true) {
      user = "all"
      if(choosenPers !== 0) user = choosenPers;
    }

    let request = "/api/performance/taux-iso?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&type-fiche=" + typeFiche;
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getDmtMoyenneParComplexite(dateDebut : string, dateFin : string, cq:number=0, all:string="", retour:string="initiales") {
    let httpHeaders = this.tokenService.loadToken();

    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === "all" || all === "0") {
      user = "all"
    }

    let request = "/api/performance/dmt-complexite?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&cq=" + cq + "&retour=" + retour;
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getListeTraitees(dateDebut : string, dateFin : string, cq:number=0, all:string="", retour:string="initiales") {
    let httpHeaders = this.tokenService.loadToken();

    let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let user = userParsed["matricule"];
    if(all === "all" || all === "0") {
      user = "all"
    }

    let request = "/api/performance/liste-traitees?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin) + "&responsable=" + user + "&cq=" + cq + "&retour=" + retour;
    
    return this.http.get(request, {headers : httpHeaders});
  }


}
